<template>
  <Column
    :fields="mgnlProps.fields"
    :horizontal-position="mgnlProps.horizontalPosition"
    :vertical-position="mgnlProps.verticalPosition"
    :margin="mgnlProps.margin"
    :margin-mobile="mgnlProps.marginMobile"
  />
</template>

<script lang="ts" setup>
import Column from './Column.vue';
import { ColumnBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Column/Column.model';

const props = defineProps(WrapperProps);
const mgnlProps = ColumnBuilder.build(props);
</script>
